import React, { useState } from 'react';
import { AppBenefitsBanner } from '@wix/app-market-components';
export const AppBenefits = ({ experiments, bundleApps, navigateToAppBenefitsPage }) => {
    const isBundlesToBenefitsExperiment = experiments.enabled('specs.app-market.MoveBundlesToBenefits');
    const [isCloseByClick, setIsCloseByClick] = useState(false);
    const hasBundleApps = !!bundleApps?.length;
    const isVisible = isBundlesToBenefitsExperiment && hasBundleApps && !isCloseByClick;
    if (!isVisible) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement("div", null,
        React.createElement(AppBenefitsBanner, { onClose: () => setIsCloseByClick(true), onMainActionClick: navigateToAppBenefitsPage }));
};
//# sourceMappingURL=AppBenefits.js.map